<template>
  <section class="text-center">
    <p>Etes-vous sûr de vouloir supprimer ce championnat ?</p>
    <div class="">
      <button @click="onSubmit" class="ml-3 btn btn-outline-success">OUI</button>
    </div>
  </section>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
name: "Delete",
  props: {
    championnat: {
      type: Object
    }
  },
  data(){
    return{}
  },
components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosDeleteData',
    ]),
    onSubmit() {
      this.axiosDeleteData({
        table: 'championnats',
        table_id: this.championnat.championnat_id,
      })
          .then(() => {
            location.reload(false)
          })
          .catch(() => {
          })
    }
  },
  computed: {
    ...mapGetters([])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/championnats/components/Delete.vue